module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medium-12"
  }, [_c('div', {
    staticClass: "margin-b-xs"
  }, [_c('label', {
    staticClass: "field-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputSignupFlag),
      expression: "inputSignupFlag"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "margin-r-xs",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inputSignupFlag) ? _vm._i(_vm.inputSignupFlag, null) > -1 : (_vm.inputSignupFlag)
    },
    on: {
      "click": _vm.showHideForm,
      "change": _vm.signupFlagChange,
      "__c": function($event) {
        var $$a = _vm.inputSignupFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.inputSignupFlag = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.inputSignupFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputSignupFlag = $$c
        }
      }
    }
  }), _vm._v(" "), (!_vm.isHidden) ? _c('i', {
    staticClass: "fas fa-check-square chkbox fa-fw"
  }) : _c('i', {
    staticClass: "far fa-square fa-fw"
  }), _vm._v("\n      " + _vm._s(_vm.$t('customerForm.createAccnt')) + "\n    ")])]), _vm._v(" "), _c('div', {
    ref: "PasswordForm",
    class: ['password-form showhide-fadeslide', (_vm.isHidden ? 'hide' : '')]
  }, [_c('form', {
    class: ['padding-a-m', _vm.isSafari],
    attrs: {
      "data-vv-scope": "password-form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 column padding-r-s small-padding-h-z"
  }, [_c('div', {
    class: {
      'field-group': true, 'field-error': _vm.errors.has('password-form.repassword')
    }
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('common.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "field-text",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": _vm.checkPasswordMatch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "medium-6 columns padding-l-s small-padding-h-z"
  }, [_c('div', {
    class: {
      'field-group': true, 'field-error': _vm.errors.has('password-form.repassword')
    }
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rpassword')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repassword),
      expression: "repassword"
    }],
    staticClass: "field-text",
    attrs: {
      "type": "password",
      "name": "repassword",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.repassword)
    },
    on: {
      "keyup": _vm.checkPasswordMatch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password-form.repassword')),
      expression: "errors.has('password-form.repassword')"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('password-form.repassword')))])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0daaa36f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0daaa36f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/PasswordForm.vue
// module id = 2033
// module chunks = 0